//import { CadastroTemplateModeloComponent } from './page/cadastro-template-modelo/cadastro-template-modelo.component';
//import { DisparoVerificarComponent } from './page/disparo-verificar/disparo-verificar.component';
//import { DispararListaComponent } from './page/disparar-lista/disparar-lista.component';
//import { CadastroListaComponent } from './page/cadastro-lista/cadastro-lista.component';

//import { HomeProgramaComponent } from './page/home-programa/home-programa.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './page/login/login.component';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { LoggedInGuard } from './page/security/loggedin.quard';
//import { HomeComponent } from './page/home/home.component';
import { CadastroUsuarioComponent } from './page/cadastro-usuario/cadastro-usuario.component';
import { AvisoComponent } from './page/aviso/aviso.component';
//import { TreeComponent } from './page/tree/tree.component';
//import { DrawFlowComponent } from './page/draw-flow/draw-flow.component';
//import { FluxoDrawComponent } from './page/fluxo-draw/fluxo-draw.component';
//import { CadastroAtendenteComponent } from './page/cadastro-atendente/cadastro-atendente.component';
//import { MotivoEncerramentoComponent } from './page/motivo-encerramento/motivo-encerramento.component';
//import { RespostasRapidasComponent } from './page/respostas-rapidas/respostas-rapidas.component';
//import { CadastroGruposComponent } from './page/cadastro-grupos/cadastro-grupos.component';
//import { ImportarContatoComponent } from './page/importar-contato/importar-contato.component';
//import { ContatoComponent } from './page/contato/contato.component';
//import { FilaAtendimentoComponent } from './page/fila-atendimento/fila-atendimento.component';
import { CadastroEmpresaComponent } from './page/cadastro-empresa/cadastro-empresa.component';
import { HomeComponent } from './page/home/home.component';
import { ListEmpresaComponent } from './page/list-empresa/list-empresa.component';
import { CadastroProgramaComponent } from './page/cadastro-programa/cadastro-programa.component';
import { ListProgramaComponent } from './page/list-programa/list-programa.component';
import { DocumentosComponent } from './page/documentos/documentos.component';
import { AlertaEmpresaComponent } from './page/alerta-empresa/alerta-empresa.component';
import { ListaProgramaEmpresaComponent } from './page/lista-programa-empresa/lista-programa-empresa.component';
import { VerDocumentosEmpresaComponent } from './page/ver-documentos-empresa/ver-documentos-empresa.component';
import { EtapasComponent } from './page/etapas/etapas.component';
import { ArtigoComponent } from './page/artigo/artigo.component';
import { JornadaComponent } from './page/jornada/jornada.component';
import { NotificacaoComponent } from './page/notificacao/notificacao.component';

const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      {
        path: 'sample-page',
        loadChildren: () => import('./demo/pages/sample-page/sample-page.module').then(module => module.SamplePageModule)
      }
      , { path: 'home', component: HomeComponent }
      , { path: 'cadastro-empresa', component: CadastroEmpresaComponent }
      , { path: 'cadastro-programa', component: CadastroProgramaComponent }
      , { path: 'lista-empresa', component: ListEmpresaComponent }
      , { path: 'lista-programa', component: ListProgramaComponent }
      , { path: 'avisos', component: AvisoComponent }
      , { path: 'documentos', component: DocumentosComponent}
      , { path: 'alerta-empresa', component: AlertaEmpresaComponent}
      , { path: 'lista-programa-empresa', component: ListaProgramaEmpresaComponent}
      , { path: 'ver-documentos-empresa', component: VerDocumentosEmpresaComponent}
      , { path: 'etapas', component: EtapasComponent}
      , { path: 'cadastro-usuario', component: CadastroUsuarioComponent}
      , { path: 'artigo', component: ArtigoComponent}
      , { path: 'jornada', component: JornadaComponent}
      , { path: 'notificacao', component: NotificacaoComponent}
      
      /*, { path: 'home', component: HomeComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'cadastro-empresa', component: CadastroEmpresaComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'cadastro-programa', component: CadastroProgramaComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'lista-empresa', component: ListEmpresaComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'lista-programa', component: ListProgramaComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'avisos', component: AvisoComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }
      , { path: 'documentos', component: DocumentosComponent, canLoad: [LoggedInGuard], canActivate: [LoggedInGuard] }*/

    ]
  }
  ,
  {
    path: '',
    component: AuthComponent,
    children: [
      { path: 'login', component: LoginComponent },
      { path: 'cadastro-usuario', component: CadastroUsuarioComponent },

    ]
  }/*,
  {
    path: '',
    component: AuthComponent,
    children: []
  }*/
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
